import GetDocumentByExternalIdRequestModelBase from '../_generated/modelBases/get-document-by-external-id-request-model-base';

export default class GetDocumentByExternalIdRequestModel extends GetDocumentByExternalIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
